// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio__C+VKD","input":"input__44MrG","label":"label__E6Am+"};